import { getAllFormSubmissions, getAssessmentFormKeys } from '@uplift/api';
import { useQuery } from '@tanstack/react-query';
import { CalendarDateService } from '@uplift/services';
import { AssessmentKeys } from '@uplift/types';
import { BaseQueryOpts } from '../baseTypes';


export const useAssessmentsKeysQuery = (opts?: BaseQueryOpts) => {
  return useQuery([ 'assessments-keys' ], () => getAssessmentFormKeys(), opts);
};


export const useAssessmentSubmissionsQuery = (patientId: string, assessmentKey?: AssessmentKeys, opts?: BaseQueryOpts) => {
  return useQuery([ 'form-submissions', patientId, assessmentKey ], async () => {
    if (!assessmentKey) return null;

    const response = await getAllFormSubmissions(assessmentKey, patientId);

    if ('error' in response) {
      throw new Error(response.error);
    }

    const submissions = response.submissions.map(submission => ({
      score: submission.score ?? 0,
      scoreDiffPercentage: submission.scoreDiffPercentage,
      submission: submission.submission,
    })) ?? [];

    submissions.sort((a, b) => CalendarDateService.compare(b.submission.createdAt, a.submission.createdAt));

    return submissions;
  }, opts);
};
